export const navigationEvent = "mvs:navigate";

/**
 * 이 앱 안에서 몇 칸째인가 — 기록 칸(history.state.idx)에 적어 둔다.
 * 🔙 §9.H-18 v2.4 「한 칸 뒤로」 — 공용 가드의 «첫 화면» 판정(isFirstInAppEntry)이 이 값을 읽는다.
 *    옛 판은 `{}` 를 적어 깊이가 없었고, 그러면 모든 화면이 «첫 화면» 으로 보인다.
 */
function depth(): number {
  const idx = (window.history.state as { idx?: unknown } | null)?.idx;
  return typeof idx === "number" ? idx : 0;
}

export function navigate(path: string, options: { replace?: boolean } = {}): void {
  if (options.replace) window.history.replaceState({ idx: depth() }, "", path);
  else window.history.pushState({ idx: depth() + 1 }, "", path);
  window.dispatchEvent(new Event(navigationEvent));
}
